import * as React from 'react';
import ProjectUpdateTeamMemberCardContainer
  from 'src/modules/project/update/partials/round-information/ProjectUpdateTeamMemberCard.container';
import './UpdateTeamMembers.css';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import ImageContainer from 'src/modules/commons/images/Image.container';
import ProjectData from 'src/value-objects/ProjectData';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectTeamMembersFormComponentProps {
  project: ProjectData;
  newTeamMember: ProjectTeamMember;
  handleChange: (key: string) => (value: string | File) => void;
  handleRichEditor: (key: string) => (value: string | File) => void;
  handleSubmit: () => void;
  errorMessage: {};
}

class ProjectTeamMembersFormComponent extends React.Component<ProjectTeamMembersFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <div>
        <p className="f-s-26">
          Equipo
        </p>
        <div className="gap-20"/>
        <div className="row padding-left-20">
          {this.props.project.teamMembers.map((teamMember, key) => (
            <div key={key}>
              <ProjectUpdateTeamMemberCardContainer
                project={this.props.project}
                teamMember={teamMember}
              />
              <div className="gap-30"/>
            </div>
          ))}
        </div>
        <div className="row padding-left-20">
          <div className="update-team-member-card padding-20 faqAccordion">
            <section
              className="accordion-toggle question-toggle collapsed pointer"
              data-toggle="collapse"
              data-parent="#faqAccordion"
              data-target="#new-team-member"
            >
              <span className="add"/>
              <div className="title margin-l-30">
                <strong className="c-grey f-s-18">
                  Añadir otro miembro del equipo
                </strong>
              </div>
            </section>
            <div
              id="new-team-member"
              className="collapse"
            >
              <div className="row">
                <div className="col-md-6">
                  <div className="row padding-l-r-10">
                    <div className="md-input">
                      <InputContainer
                        label="Nombre completo"
                        type="text"
                        value={this.props.newTeamMember.fullName}
                        onChange={(value) => this.props.handleChange('fullName')(value)}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="row padding-l-r-10">
                    <div className="md-input">
                      <InputContainer
                        label="Posición"
                        type="text"
                        value={this.props.newTeamMember.jobTitle}
                        onChange={(value) => this.props.handleChange('jobTitle')(value)}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="row padding-l-r-10">
                    <div className="md-input">
                      <InputContainer
                        label="Usuario Linkedin"
                        type="text"
                        value={this.props.newTeamMember.linkedinProfile || ''}
                        onChange={(value) => this.props.handleChange('linkedinProfile')(value)}
                        required={false}
                      />
                    </div>
                  </div>
                  <div className="row padding-l-r-10">
                    <ReactDropzone
                      className="dropzone text-center pointer"
                      onDrop={(files: ImageFile[]) => {
                        if (files[0]) {
                          this.props.handleChange('profilePicture')(files[0]);
                        }
                      }}
                      multiple={false}
                      accept="image/*"
                    >
                      <ImageContainer
                        alt="profile picture"
                        url={
                          (this.props.newTeamMember.profilePicture && !this.props.newTeamMember.profilePicture.encoded)
                            ? this.props.newTeamMember.profilePicture.url : ''
                        }
                        defaultImagePath={
                          this.props.newTeamMember.profilePicture ?
                            this.props.newTeamMember.profilePicture.url :
                            '/img/pic.png'
                        }
                      />
                      <div className="gap-10"/>
                      <p className="text-center">
                        Arrastre una foto / Clique aquí...
                      </p>
                    </ReactDropzone>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row padding-left-20">
                    <p className="c-grey-dark f-s-16">Descripción (*)</p>
                    <RichEditContainer
                      onChange={(value) => this.props.handleRichEditor('description')(value)}
                      placeholder="Añade la descripción del miembro del equipo"
                      uploadURL={baseApiRoute + '/save-image'}
                      value={this.props.newTeamMember.description}
                    />
                  </div>
                </div>
              </div>
              <div className="add-team-member text-right">
                <div className="gap-20"/>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-container="body"
                  data-html="true"
                  data-toggle="popover"
                  data-placement="bottom"
                  onClick={(e) => this.props.handleSubmit()}
                >
                  Añadir
                </button>
                <div className="gap-20"/>
                <ErrorMessagesComponent
                  errorMessage={this.props.errorMessage}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectTeamMembersFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectTeamMembersForm.component.tsx